<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

        <!-- breadcrumb -->
        <div class="page-header-content d-lg-flex">
            <div class="d-flex">
                <h4 class="page-title mb-0">
                    <router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
                    <a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer"> Cms </a>
					<span class="hidden-xs ms-1">\</span>
                    <span class="text-muted ms-1">Chat</span>
                </h4>
                <a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
                    <i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
                </a>
            </div>
            <div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
                <div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

                    <a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 me-2 position-10" style="text-align: left;">

                    </a>

                    <div class="vr flex-shrink-0 my-2 mx-3"></div>

                    <div class="d-inline-flex float-end mt-sm-0">
                        <a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche()" title="Opzioni Prodotto" data-bs-toggle="tooltip" data-bs-placement="left">
                            <i class="ph-lightning"></i>
                        </a>
                        <a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue()" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
                            <i class="ph-flag"></i>
                        </a>
                        <a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help()" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
                            <i class="icon-question7" style="color: orange;"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- /breadcrumb -->

        <!-- Profile navigation -->
        <div class="navbar navbar-expand-lg border-top py-1">
            <div class="container-fluid">
                <ul class="nav navbar-nav flex-row flex-fill" role="tablist">
                    <li class="nav-item me-1" role="presentation">
                        <a href="#chat-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
                            <div class="d-flex align-items-center mx-lg-1">
                                <i class="icon-menu7 me-2"></i>Chat
                            </div>
                        </a>
                    </li>
                    <li>
                        <button type="button" class="navbar-toggler rounded-pill d-md-none" data-bs-toggle="offcanvas" data-bs-target="#chatListOffcanvas">
                            <i class="ph-arrow-left"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <!-- /profile navigation -->

    </div>
    <!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 chat-container" :style="containerHeight ? { height: containerHeight + 'px', overflow: 'hidden' } : {}">

        <div class="d-lg-flex" style="height:100%;">

            <!-- Left sidebar / mobile offcanvas -->
            <div class="offcanvas-md offcanvas-start me-lg-3" id="chatListOffcanvas" tabindex="-1">
                <div class="offcanvas-header bg-secondary text-white">
                    <h5 class="offcanvas-title fw-semibold"><i class="ph-chats-circle me-2"></i> Chat</h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" data-bs-target="#chatListOffcanvas"></button>
                </div>
                <div class="offcanvas-body">
                    <div class="sidebar sidebar-component sidebar-expand-lg bg-transparent shadow-none" style="width: 360px; display: block;">
                        <div class="sidebar-content list-chat">

                            <ListChat
                                :ref="'listChat'"
								@chat-selezionata="handleChatSelezionata"
								:arrayUtentiAdmin="$root.arrayUtentiAdmin"
                                :writingState="writingState"
							/>

                        </div>
                    </div>
                </div>
            </div>
            <!-- /left sidebar -->

            <!-- Right content -->
            <div class="flex-1">

                <div class="chat-comp" v-if="chatSelezionata" :class="{ 'chat-comp-mobile': isMobile }" @click.stop>

                    <ChatComp
                        :ref="'chatComp'"
						@messageSent="updateLastMessage"
                        @isWriting="updateWritingState"
                        @stopWriting="updateWritingState"
                        :chatId="chatSelezionata.ID_CHAT"
                        :chatLabel="chatLabel"
                        @close="closeChatComp"
                        :arrayUtentiAdmin="$root.arrayUtentiAdmin"
                        @updateUnreadMessages="handleUpdateUnreadMessages"
                        @messaggiAggiornati="handleAggiornaChat"
					/>
                </div>

            </div>
            <!-- /right content -->

        </div>
    </div>

</template>



<script>

import ListChat from '../../components/ListChat';
import ChatComp from '../../components/ChatComp.vue';

export default {
    components: {
        ListChat,
        ChatComp
    },

    data() {
        return {
            chatSelezionata: null,
            isMobile: false,
            writingState: {},
            containerHeight: null,
            chatLabel: ''
        };
    },

    methods: {
        handleChatSelezionata(chat) {
            this.chatSelezionata = chat;
            if (chat.NOME_GRUPPO) {
                this.chatLabel = chat.NOME_GRUPPO;
            } else if (chat.utenti) {
                this.chatLabel = chat.utenti
                    .filter(u => u.ID_UTENTE != this.$root.utente.ID_UTENTE)
                    .map(u => u.USERNAME)
                    .join(', ');
            }
            this.hideChatListOffcanvas();
            if (this.$refs.chatComp) {
                this.$refs.chatComp.resetMessageInput();
            }
        },

        updateWritingState(data) {
            const { chatId, userId, username, isWriting } = data;
            if (userId !== this.$root.utente.ID_UTENTE) {
                this.writingState = {
                    ...this.writingState,
                    [chatId]: { userId, username, isWriting }
                };
            }
        },

        closeChatComp() {
            this.chatSelezionata = null;
            if (this.isMobile) this.showChatListOffcanvas();
        },

        showChatListOffcanvas() {
            if (!this.isMobile) return;
            const el = document.getElementById('chatListOffcanvas');
            if (el) bootstrap.Offcanvas.getOrCreateInstance(el).show();
        },

        hideChatListOffcanvas() {
            const el = document.getElementById('chatListOffcanvas');
            const inst = el ? bootstrap.Offcanvas.getInstance(el) : null;
            if (inst) inst.hide();
        },

        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
            this.setContainerHeight();
        },

        setContainerHeight() {
            if (window.innerWidth <= 768) {
                this.containerHeight = null;
                return;
            }
            const pageHeader = document.querySelector('.page-header');
            if (pageHeader) {
                this.containerHeight = window.innerHeight - pageHeader.getBoundingClientRect().bottom;
            }
        },

        aggiornaListChat(){
            this.$refs.listChat.getChat();
        },

        updateLastMessage(messaggio) {
            this.$refs.listChat.updateChatLastMessage(messaggio);
        },

        handleAggiornaChat(){
            if(this.chatSelezionata){
                this.$refs.chatComp.getMessaggiPerChat();
            }
        },

        handleUpdateUnreadMessages({chatId}){
            this.$refs.listChat.updateUnreadMessages(chatId)
        },

        setupSocketListeners() {
            this._onTyping = (data) => { this.updateWritingState(data); };
            this._onStopTyping = (data) => { this.updateWritingState(data); };
            this.$root.appoggio.socket.on('typing', this._onTyping);
            this.$root.appoggio.socket.on('stopTyping', this._onStopTyping);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.setContainerHeight();
            if (this.isMobile && !this.chatSelezionata) this.showChatListOffcanvas();
        });
    },

    created() {
        this.setupSocketListeners();
        this.checkMobile();
        window.addEventListener("resize", this.checkMobile);
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.checkMobile);
        if (this.$root.appoggio && this.$root.appoggio.socket) {
            this.$root.appoggio.socket.off('typing', this._onTyping);
            this.$root.appoggio.socket.off('stopTyping', this._onStopTyping);
        }
    }

};
</script>


<style>
    .close-btn{position:absolute;top:10px;right:10px;background:0 0;border:none;font-size:24px;font-weight:700;cursor:pointer;color:#888}
    .close-btn:hover{color:#000}

    /* azzera il margin-bottom del tema sulle card della chat (allinea i due lati, tutte le larghezze) */
    .chat-container .card{margin-bottom:0}

    /* Desktop: full-height layout */
    @media (min-width:769px){
        .chat-container>.d-lg-flex{height:100%;align-items:stretch}
        .chat-container .sidebar-component,.chat-container .sidebar-content.list-chat{height:100%;display:flex;flex-direction:column}
        .chat-container .flex-1{height:100%;display:flex;flex-direction:column;min-height:0}
        .chat-container .chat-comp{height:100%;min-height:0;display:flex;flex-direction:column}
        /* stesso spazio sotto quanto sopra (top 0.8rem da .content-1) */
        .chat-container.content-1{padding-bottom:0.8rem !important}
        /* catena flex della lista chat: unica fonte in custom.css (.list-chat ...) */
        /* wrapper offcanvas responsive nella catena full-height */
        .chat-container .offcanvas-md{height:100%;display:flex;flex-direction:column}
        .chat-container .offcanvas-md .offcanvas-body{height:100%;min-height:0;display:flex;flex-direction:column;flex:1;padding:0}
    }

    /* Mobile: offcanvas Bootstrap nativo (offcanvas-md) */
    @media (max-width:768px){
        .chat-container{padding:0;overflow:hidden}
        .chat-container .offcanvas-md .sidebar{width:100% !important}
        /* tutto l'offcanvas dentro il viewport: scrolla solo .box-chat, non l'intero offcanvas */
        .chat-container .offcanvas-md .offcanvas-body{min-height:0;display:flex;flex-direction:column;overflow:hidden;padding:0}
        .chat-container .offcanvas-md .sidebar-component,
        .chat-container .offcanvas-md .sidebar-content.list-chat{height:100%;min-height:0;display:flex;flex-direction:column}
        .chat-comp{z-index:10;width:100%}
        .chat-comp-mobile{background-color:#fff}
    }
</style>
